// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-system {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  background: var(--bg-primary);
}

.faq-header {
  text-align: center;
  margin-bottom: 2rem;
}

.faq-title {
  font-size: 2.2rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 0.5rem;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.faq-subtitle {
  font-size: 1rem;
  color: var(--text-secondary);
  margin: 0 auto;
  max-width: 500px;
  line-height: 1.5;
}

.faq-search-section {
  margin-bottom: 1.5rem;
}

/* Section Labels */
.section-label {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid var(--border-primary);
}

/* Search Results Area */
.search-results-area {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.results-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 0.75rem;
}

/* Guide Results in Search */
.guide-results-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.guide-result-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.2s ease;
  border-left: 3px solid var(--accent-primary);
}

.guide-result-card:hover {
  background: var(--bg-tertiary);
  border-color: var(--accent-primary);
}

.guide-result-icon {
  font-size: 1.3rem;
  flex-shrink: 0;
}

.guide-result-title {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.9rem;
}

.guide-result-desc {
  color: var(--text-secondary);
  font-size: 0.8rem;
  margin-top: 0.15rem;
}

/* FAQ Results in Search */
.faq-results-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.faq-result-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 10px;
  overflow: hidden;
  transition: border-color 0.2s ease;
}

.faq-result-card.expanded {
  border-color: var(--accent-primary);
}

.faq-result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.75rem 1rem;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  gap: 0.75rem;
  color: inherit;
}

.faq-result-question {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
  flex: 1;
  line-height: 1.4;
}

.faq-expand-icon {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--accent-primary);
  flex-shrink: 0;
  width: 1.5rem;
  text-align: center;
}

.faq-result-answer {
  overflow: hidden;
}

.faq-result-answer p {
  padding: 0 1rem 1rem;
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.85rem;
  line-height: 1.7;
}

/* No Results */
.no-results {
  text-align: center;
  padding: 2.5rem 1.5rem;
  background: var(--bg-secondary);
  border-radius: 12px;
  border: 1px solid var(--border-primary);
}

.no-results h3 {
  font-size: 1.1rem;
  color: var(--text-primary);
  margin: 0 0 0.5rem;
}

.no-results p {
  color: var(--text-secondary);
  margin: 0;
  font-size: 0.9rem;
}

/* Guides Overview */
.guides-overview {
  margin-bottom: 2.5rem;
}

.guides-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

.guide-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.25s ease;
}

.guide-card:hover {
  border-color: var(--accent-primary);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px var(--shadow-primary);
}

.guide-card-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.guide-card-title {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.9rem;
  margin-bottom: 0.15rem;
}

.guide-card-desc {
  color: var(--text-secondary);
  font-size: 0.78rem;
  line-height: 1.4;
}

/* FAQ Categories */
.faq-categories-section {
  margin-bottom: 2rem;
}

.category-pills {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
}

.category-pill {
  padding: 0.4rem 0.9rem;
  border-radius: 20px;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.category-pill:hover {
  border-color: var(--accent-primary);
  color: var(--text-primary);
}

.category-pill.active {
  background: var(--accent-primary);
  color: white;
  border-color: var(--accent-primary);
}

/* FAQ Accordion */
.faq-accordion {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.faq-accordion-item {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 10px;
  overflow: hidden;
  transition: border-color 0.2s ease;
}

.faq-accordion-item.expanded {
  border-color: var(--accent-primary);
}

.faq-accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.75rem 1rem;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  gap: 0.5rem;
  color: inherit;
  min-height: 44px;
}

.faq-accordion-question {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-primary);
  flex: 1;
  line-height: 1.4;
}

.faq-accordion-icon {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--accent-primary);
  flex-shrink: 0;
  width: 1.5rem;
  text-align: center;
}

.faq-accordion-body {
  overflow: hidden;
}

.faq-accordion-body p {
  padding: 0 1rem 1rem;
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.85rem;
  line-height: 1.7;
}

/* Mobile */
@media (max-width: 680px) {
  .faq-system {
    padding: 1.5rem 1rem;
  }

  .faq-title {
    font-size: 1.6rem;
  }

  .guides-grid {
    grid-template-columns: 1fr;
  }

  .category-pills {
    gap: 0.3rem;
  }

  .category-pill {
    padding: 0.35rem 0.7rem;
    font-size: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/faq/FAQSystem.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF","sourcesContent":[".faq-system {\r\n  max-width: 900px;\r\n  margin: 0 auto;\r\n  padding: 2rem 1.5rem;\r\n  background: var(--bg-primary);\r\n}\r\n\r\n.faq-header {\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.faq-title {\r\n  font-size: 2.2rem;\r\n  font-weight: 800;\r\n  color: var(--text-primary);\r\n  margin: 0 0 0.5rem;\r\n  background: var(--gradient-primary);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.faq-subtitle {\r\n  font-size: 1rem;\r\n  color: var(--text-secondary);\r\n  margin: 0 auto;\r\n  max-width: 500px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.faq-search-section {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n/* Section Labels */\r\n.section-label {\r\n  font-size: 1.1rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0 0 1rem;\r\n  padding-bottom: 0.5rem;\r\n  border-bottom: 2px solid var(--border-primary);\r\n}\r\n\r\n/* Search Results Area */\r\n.search-results-area {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.results-section-title {\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  color: var(--text-secondary);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  margin: 0 0 0.75rem;\r\n}\r\n\r\n/* Guide Results in Search */\r\n.guide-results-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.guide-result-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 0.75rem 1rem;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-primary);\r\n  border-radius: 10px;\r\n  text-decoration: none;\r\n  transition: all 0.2s ease;\r\n  border-left: 3px solid var(--accent-primary);\r\n}\r\n\r\n.guide-result-card:hover {\r\n  background: var(--bg-tertiary);\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.guide-result-icon {\r\n  font-size: 1.3rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.guide-result-title {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.guide-result-desc {\r\n  color: var(--text-secondary);\r\n  font-size: 0.8rem;\r\n  margin-top: 0.15rem;\r\n}\r\n\r\n/* FAQ Results in Search */\r\n.faq-results-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.faq-result-card {\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-primary);\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.faq-result-card.expanded {\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.faq-result-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n  padding: 0.75rem 1rem;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  gap: 0.75rem;\r\n  color: inherit;\r\n}\r\n\r\n.faq-result-question {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  flex: 1;\r\n  line-height: 1.4;\r\n}\r\n\r\n.faq-expand-icon {\r\n  font-size: 1.2rem;\r\n  font-weight: 700;\r\n  color: var(--accent-primary);\r\n  flex-shrink: 0;\r\n  width: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.faq-result-answer {\r\n  overflow: hidden;\r\n}\r\n\r\n.faq-result-answer p {\r\n  padding: 0 1rem 1rem;\r\n  margin: 0;\r\n  color: var(--text-secondary);\r\n  font-size: 0.85rem;\r\n  line-height: 1.7;\r\n}\r\n\r\n/* No Results */\r\n.no-results {\r\n  text-align: center;\r\n  padding: 2.5rem 1.5rem;\r\n  background: var(--bg-secondary);\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border-primary);\r\n}\r\n\r\n.no-results h3 {\r\n  font-size: 1.1rem;\r\n  color: var(--text-primary);\r\n  margin: 0 0 0.5rem;\r\n}\r\n\r\n.no-results p {\r\n  color: var(--text-secondary);\r\n  margin: 0;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Guides Overview */\r\n.guides-overview {\r\n  margin-bottom: 2.5rem;\r\n}\r\n\r\n.guides-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 0.75rem;\r\n}\r\n\r\n.guide-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 1rem;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-primary);\r\n  border-radius: 12px;\r\n  text-decoration: none;\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.guide-card:hover {\r\n  border-color: var(--accent-primary);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px var(--shadow-primary);\r\n}\r\n\r\n.guide-card-icon {\r\n  font-size: 1.5rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.guide-card-title {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  font-size: 0.9rem;\r\n  margin-bottom: 0.15rem;\r\n}\r\n\r\n.guide-card-desc {\r\n  color: var(--text-secondary);\r\n  font-size: 0.78rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n/* FAQ Categories */\r\n.faq-categories-section {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.category-pills {\r\n  display: flex;\r\n  gap: 0.4rem;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.category-pill {\r\n  padding: 0.4rem 0.9rem;\r\n  border-radius: 20px;\r\n  border: 1px solid var(--border-primary);\r\n  background: var(--bg-secondary);\r\n  color: var(--text-secondary);\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.category-pill:hover {\r\n  border-color: var(--accent-primary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.category-pill.active {\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n/* FAQ Accordion */\r\n.faq-accordion {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.faq-accordion-item {\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-primary);\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.faq-accordion-item.expanded {\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.faq-accordion-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n  padding: 0.75rem 1rem;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  gap: 0.5rem;\r\n  color: inherit;\r\n  min-height: 44px;\r\n}\r\n\r\n.faq-accordion-question {\r\n  font-size: 0.88rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  flex: 1;\r\n  line-height: 1.4;\r\n}\r\n\r\n.faq-accordion-icon {\r\n  font-size: 1.2rem;\r\n  font-weight: 700;\r\n  color: var(--accent-primary);\r\n  flex-shrink: 0;\r\n  width: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.faq-accordion-body {\r\n  overflow: hidden;\r\n}\r\n\r\n.faq-accordion-body p {\r\n  padding: 0 1rem 1rem;\r\n  margin: 0;\r\n  color: var(--text-secondary);\r\n  font-size: 0.85rem;\r\n  line-height: 1.7;\r\n}\r\n\r\n/* Mobile */\r\n@media (max-width: 680px) {\r\n  .faq-system {\r\n    padding: 1.5rem 1rem;\r\n  }\r\n\r\n  .faq-title {\r\n    font-size: 1.6rem;\r\n  }\r\n\r\n  .guides-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .category-pills {\r\n    gap: 0.3rem;\r\n  }\r\n\r\n  .category-pill {\r\n    padding: 0.35rem 0.7rem;\r\n    font-size: 0.75rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
